import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { COMPANY } from '../data/content.js'
import SocialRow from '../components/SocialRow.jsx'

export default function Contact() {
  const { t } = useTranslation()
  const [form, setForm] = useState({ name: '', company: '', phone: '', message: '' })

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!form.phone.trim()) return
    const body = [
      t('contact.formSubject'),
      '',
      `${t('contact.name')}: ${form.name || '—'}`,
      `${t('contact.company')}: ${form.company || '—'}`,
      `${t('contact.phoneLabel')}: ${form.phone}`,
      '',
      `${t('contact.message')}: ${form.message || '—'}`,
    ].join('\n')
    window.open(`https://wa.me/${COMPANY.whatsapp.replace(/\D/g, '')}?text=${encodeURIComponent(body)}`, '_blank', 'noopener,noreferrer')
    setForm({ name: '', company: '', phone: '', message: '' })
  }

  const input = (key) => ({
    value: form[key],
    onChange: (e) => setForm({ ...form, [key]: e.target.value }),
  })

  return (
    <section className="section">
      <div className="container">
        <p className="eyebrow">Almus</p>
        <h1 className="section-title">{t('contact.title')}</h1>

        <div className="contact-layout">
          <form className="contact-form" onSubmit={handleSubmit}>
            <label>
              {t('contact.name')}
              <input type="text" name="name" required {...input('name')} />
            </label>
            <label>
              {t('contact.company')}
              <input type="text" name="company" {...input('company')} />
            </label>
            <label>
              {t('contact.phoneLabel')} *
              <input type="tel" name="phone" required placeholder="+7 ___ ___ __ __" {...input('phone')} />
            </label>
            <label className="full">
              {t('contact.message')}
              <textarea name="message" rows={4} {...input('message')} />
            </label>
            <button type="submit" className="btn btn-primary full" style={{ width: '100%' }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.13 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
              </svg>
              {t('contact.submit')}
            </button>
          </form>

          <div>
            <div className="contact-info-item">
              <p className="eyebrow-label">{t('contact.address')}</p>
              <span className="value">{COMPANY.address}</span>
            </div>
            <div className="contact-info-item">
              <p className="eyebrow-label">{t('contact.phoneLabel')}</p>
              <a className="value" href={`tel:${COMPANY.phone.replace(/\s/g, '')}`}>{COMPANY.phone}</a>
            </div>
            <div className="contact-info-item">
              <p className="eyebrow-label">{t('contact.whatsapp')}</p>
              <a className="value" href={`https://wa.me/${COMPANY.whatsapp.replace(/\D/g, '')}`} target="_blank" rel="noopener noreferrer">{COMPANY.whatsapp}</a>
            </div>
            <div className="contact-info-item">
              <p className="eyebrow-label">Email</p>
              <a className="value" href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
            </div>
            <div>
              <p className="eyebrow-label">{t('contact.social')}</p>
              <SocialRow />
            </div>
          </div>
        </div>

        <div className="map">
          <iframe
            title="Almus office"
            src="https://www.google.com/maps?q=Шевченко+29,+Алматы,+Қазақстан&output=embed"
            width="100%"
            height="400"
            style={{ border: 0, display: 'block' }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  )
}